import React, { useContext, useEffect, useRef, useState } from 'react';
import cvPdf from '../Portfolio/Assets/Adil_KK.pdf';
import { Icon } from '@iconify/react/dist/iconify.js';
import { addcontext } from '../ContextShare/ContextShare';
import { motion } from 'framer-motion'; // Import motion from framer-motion
import profile from '../Portfolio/Assets/WhatsApp Image 2024-10-05 at 3.40.55 PM.jpeg'
import './chat.css'
function ChatBoat() {
    const { ContactOpened, setContactOpened } = useContext(addcontext);
    const [sayHello, setSayHello] = useState(false);
    const [hireYou, setHireYou] = useState(false);
    const [msgMe, setMsgMe] = useState(false);
    const [hireOp, sethireOp] = useState(false);
    const [chatOp, setChatOp] = useState(false);
    const [hire2, sethire2] = useState(false)
    const chatRef = useRef(null); // Create a ref for the chat box container
    const messageContainerRef = useRef(null); // Create a ref for the message container

    useEffect(() => {
        // Function to handle clicks outside the chat box
        const handleClickOutside = (event) => {
            if (chatRef.current && !chatRef.current.contains(event.target)) {
                setContactOpened(false); // Close the chatbot if clicked outside
            }
        };

        // Attach event listener when component mounts
        document.addEventListener('mousedown', handleClickOutside);

        // Clean up the event listener when component unmounts
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [setContactOpened]);

    const scrollToBottom = () => {
        if (messageContainerRef.current) {
            messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
        }

    };

    const handleHireYou = () => {
        setHireYou(true);
        setTimeout(() => {
            sethireOp(true);
            scrollToBottom(); // Scroll to bottom when messages are displayed
        }, 300);
        setTimeout(() => {
            sethire2(true);
            scrollToBottom(); // Scroll to bottom when messages are displayed
        }, 600);
        setSayHello(false)
        setChatOp(false)
    };

    const handleSayHello = () => {
        setSayHello(true);
        setHireYou(false);
        setMsgMe(false);
        sethireOp(false);
        sethire2(false)
        setTimeout(() => {
            setChatOp(true);
            scrollToBottom(); // Scroll to bottom when messages are displayed
        }, 500);
        // scrollToBottom(); // Scroll to bottom when messages are displayed
    };

    const handleSendMessage = () => {
        setMsgMe(true);
        scrollToBottom(); // Scroll to bottom when messages are displayed
    };

    const handleCvDownload = () => {
        const cvPdfUrl = cvPdf; // Update with the actual path to your CV PDF file
        const link = document.createElement('a');
        link.href = cvPdfUrl;
        link.download = 'Adil_kk.pdf'; // This will be the name of the downloaded file
        link.click();
    };

    const handleWhatsappMsg = () => {
        const phoneNumber = "+919946241459"; // Your WhatsApp number
        const message = "Hello Adil! I would like to hire you, are you open to discuss more?";
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, '_blank');
    };

    const handleEmail = () => {
        const email = "adilkkinbox@gmail.com";
        const subject = "We would like to hire";
        const body = "Hello Adil! I would like to hire you. Are you open to discuss more?";

        // Construct Gmail compose link
        const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

        // Open Gmail compose in a new tab
        window.open(gmailLink, '_blank');
    };

    return (
        <div ref={chatRef} className='flex flex-col justify-start items-start md:w-3/12 w-full md:px-0  h-[620px] pb-10 rounded-lg bg-[#080808] border border-dashed border-gray-700 shadow' style={{ fontFamily: 'Ropa sans' }}>
            <div className='bg-purple-950 h-20 w-full rounded-t-lg flex justify-start ps-5 gap-5 items-center flex-row'>
                <div className='w-16 h-16 border-2 rounded-full bg-gray-900'>
                    <img src={profile} className='w-full h-full rounded-full' alt="" />
                </div>
                <div className='flex flex-col'>
                    <p className='text-bold text-gray-100 text-xl'>Chat Bot</p>
                    <p className='text-gray-200'>Ask me a question</p>
                </div>
                <div className='absolute right-10'>
                    <button className='text-white font-bold px-2 py-1 rounded bg-purple-900' onClick={() => setContactOpened(false)}><Icon icon="iconamoon:close-bold" /></button>
                </div>
            </div>

            <div ref={messageContainerRef} className='flex flex-col w-full h-full overflow-y-scroll hide-scroll-bar'>
                <div className='flex flex-col justify-start w-full items-start'>
                    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
                        <div className='ps-4 pe-6 pt-3 '>
                            <p className='px-8 py-2 rounded-xl bg-gray-800 text-purple-400'>Hi!</p>
                        </div>
                    </motion.div>
                    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
                        <div className='ps-4 pe-6 pt-3 '>
                            <p className='px-8 py-2 rounded-xl bg-gray-800 text-purple-400'>I'm Adil Bot. I'm here to help you with any questions you might have about Adil's work.</p>
                        </div>
                    </motion.div>
                    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
                        <div className='ps-4 pe-6 pt-3 '>
                            <p className='px-8 py-2 rounded-xl bg-gray-800 text-purple-400'>How can I help you today?</p>
                        </div>
                    </motion.div>
                </div>

                <div className='flex flex-col justify-start w-full items-start'>
                    <div className='ps-4 pe-6 pt-3 '>
                        <button className='px-8 py-2 rounded-full border border-purple-900 hover:bg-gray-900 text-purple-400' onClick={handleHireYou}>We'd like to hire you</button>
                    </div>
                    <div className='ps-4 pe-6 pt-3 '>
                        <button className='px-8 py-2 rounded-full border border-purple-900 hover:bg-gray-900 text-purple-400' onClick={handleSayHello}>Just saying hello!</button>
                    </div>
                    <div className='ps-4 pe-6 pt-3 '>
                        <button className='px-8 py-2 rounded-full border border-purple-900 hover:bg-gray-900 text-purple-400' onClick={handleSendMessage}>Send me a message</button>
                    </div>
                    <div className='ps-4 pe-6 pt-3 '>
                        <button className='px-8 py-2 rounded-full border border-purple-900 hover:bg-gray-900 text-purple-400' onClick={handleCvDownload}>Download your CV</button>
                    </div>
                </div>

                {(sayHello) && (
                    <div className='flex flex-col justify-end w-full items-end'>
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} onClick={scrollToBottom}>
                            <div className='ps-4 pe-6 pt-3 '>
                                <p className='px-8 py-2 rounded-xl bg-purple-800 text-purple-400'>Just saying hello!</p>
                            </div>
                        </motion.div>
                    </div>
                )}

                {(chatOp) && (
                    <div className='flex flex-col justify-start w-full items-start'>
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} onClick={scrollToBottom}>
                            <div className='ps-4 pe-6 pt-3 '>
                                <p className='px-8 py-2 rounded-xl bg-gray-800 text-purple-400'>Hello!</p>
                            </div>
                        </motion.div>
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} onClick={scrollToBottom}>
                            <div className='ps-4 pe-6 pt-3 '>
                                <p className='px-8 py-2 rounded-xl bg-gray-800 text-purple-400'>Thanks for saying hi 😁.</p>
                            </div>
                        </motion.div>
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} onClick={scrollToBottom}>
                            <div className='ps-4 pe-6 pt-3 '>
                                <p className='px-8 py-2 rounded-xl bg-gray-800 text-purple-400'>I'm always here to assist you!</p>
                            </div>
                        </motion.div>
                    </div>
                )}

                {(hireYou) && (
                    <div className='flex flex-col justify-end w-full items-end'>
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} onClick={scrollToBottom}>
                            <div className='ps-4 pe-6 pt-3 '>
                                <p className='px-8 py-2 rounded-xl bg-purple-800 text-purple-400'>We'd like to hire you</p>
                            </div>
                        </motion.div>
                    </div>
                )}

                {(hireOp) && (
                    <div className='flex flex-col justify-start w-full items-start'>
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} onClick={scrollToBottom}>
                            <div className='ps-4 pe-6 pt-3 '>
                                <p className='px-8 py-2 rounded-xl bg-gray-800 text-purple-400'>Ok, great!</p>
                            </div>
                        </motion.div>
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} onClick={scrollToBottom}>
                            <div className='ps-4 pe-6 pt-3 '>
                                <p className='px-8 py-2 rounded-xl bg-gray-800 text-purple-400'>Exciting times 🕺</p>
                            </div>
                        </motion.div>
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} onClick={scrollToBottom}>
                            <div className='ps-4 pe-6 pt-3 '>
                                <p className='px-8 py-2 rounded-xl bg-gray-800 text-purple-400'>Send me a message and lets chat further see below details!</p>
                            </div>
                        </motion.div>
                    </div>
                )}

                {(hire2) && (
                    <div className='flex flex-col justify-start w-full items-start'>
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} onClick={scrollToBottom}>
                            <div className='ps-4 pe-6 pt-3 '>
                                <button className='px-8 py-2 rounded-full border border-purple-900 bg-gray-900 hover:bg-gray-800 text-purple-400 flex flex-row items-center gap-1' onClick={handleWhatsappMsg}><span>Message me on Whatsapp</span><Icon icon="prime:external-link" /></button>                            </div>
                        </motion.div>
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} onClick={scrollToBottom}>
                            <div className='ps-4 pe-6 pt-3 '>
                                <button className='px-8 py-2 rounded-full border border-purple-900 bg-gray-900 hover:bg-gray-800 text-purple-400 flex flex-row items-center gap-1' onClick={handleEmail}><span>Contact via Email</span><Icon icon="prime:external-link" /></button>                            </div>
                        </motion.div>

                    </div>
                )}

                {(msgMe) && (
                    <div className='flex flex-col justify-end w-full items-end'>
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} onClick={scrollToBottom}>
                            <div className='ps-4 pe-6 pt-3 '>
                                <p className='px-8 py-2 rounded-xl bg-purple-800 text-purple-400'>Send me a message</p>
                            </div>
                        </motion.div>
                    </div>
                )}

                {(msgMe) && (
                    <div className='flex flex-col justify-start w-full items-start'>
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} onClick={scrollToBottom}>
                            <div className='ps-4 pe-6 pt-3 '>
                                <button className='px-8 py-2 rounded-full border border-purple-900 bg-gray-900 hover:bg-gray-800 text-purple-400 flex flex-row items-center gap-1' onClick={handleWhatsappMsg}><span>Message me on Whatsapp</span><Icon icon="prime:external-link" /></button>                            </div>
                        </motion.div>
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} onClick={scrollToBottom}>
                            <div className='ps-4 pe-6 pt-3 '>
                                <button className='px-8 py-2 rounded-full border border-purple-900 bg-gray-900 hover:bg-gray-800 text-purple-400 flex flex-row items-center gap-1' onClick={handleEmail}><span>Contact via Email</span><Icon icon="prime:external-link" /></button>                            </div>
                        </motion.div>

                    </div>
                )}
            </div>
        </div>
    );
}

export default ChatBoat;
